import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { getCities } from 'models/cities'; // Importing getCities function from cities model
import { getTags } from 'models/tags'; // Importing getTags function from tags model
import { getPositions } from 'models/positions'; // Importing getPositions function from positions model
import 'webix/photo'; // Importing webix photo module
import 'webix/tinymce/tinymce'; // Importing TinyMCE editor from webix
import { devConfig, profile } from 'config/config'; // Importing devConfig and profile from config

/**
 * Class representing the FilterCasinoReportView.
 * @extends JetView
 */
export default class FilterCasinoReportView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        const left = {
            // Left section of the form
            margin: 5,
            rows: [
                {
                    view: 'text', // Text input for date range
                    name: 'Datepicker',
                    id: 'Datepicker',
                    css: 'reportrange',
                    readonly: true,
                    label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Localized placeholder
                },
                {
                    view: 'datepicker', // Datepicker input for creation date
                    name: 'Date',
                    id: 'Date',
                    stringResult: true,
                    minWidth: 200,
                    label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha de creación'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Localized placeholder
                    value: moment().format('YYYY-MM-DD'), // Default value set to today's date
                    format: '%d %M %Y',
                    suggest: {
                        type: 'calendar',
                        body: {
                            maxDate: new Date(), // Maximum date set to today
                        },
                    },
                },
            ],
        };

        const center_left = {
            // Center left section for product selection
            margin: 5,
            rows: [
                {
                    view: 'richselect', // Rich select for product
                    name: 'ProductId',
                    localId: 'product:combo',
                    label: _('Producto'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Localized placeholder
                    options: [], // Options to be populated later
                },
            ],
        };

        const center_right = {
            // Center right section for provider selection
            margin: 5,
            rows: [
                {
                    view: 'richselect', // Rich select for provider
                    name: 'ProviderId',
                    localId: 'provider:combo',
                    label: _('Proveedor'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Localized placeholder
                    options: [], // Options to be populated later
                },
            ],
        };

        const right = {
            // Right section for test selection
            margin: 5,
            rows: [
                {
                    view: 'richselect', // Rich select for test indication
                    name: 'IsTest',
                    localId: 'isTest:combo',
                    label: _('Es Test'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Localized placeholder
                    options: [], // Options to be populated later
                },
            ],
        };

        const upper_section = {
            // Upper section combining all parts
            cols: [
                left,
                { gravity: 0, minWidth: 10 },
                center_left,
                { gravity: 0, minWidth: 10 },
                center_right,
                { gravity: 0, minWidth: 10 },
                right,
            ],
        };

        const buttons = {
            // Button section for actions
            margin: 10,
            cols: [
                {},
                {
                    view: 'button', // Clear button
                    value: _('Limpiar'), // Localized label
                    autowidth: true,
                    click: () => {
                        this.getRoot().clear(); // Clears the form
                    },
                },
                {
                    view: 'button', // Consult button
                    value: _('Consultar'), // Localized label
                    type: 'form',
                    autowidth: true,
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Get form values
                        if (profile.typeDate !== 2) {
                            delete filterdata['Date']; // Remove Date if typeDate is not 2
                        } else {
                            if (true) {
                                delete filterdata['Datepicker']; // Remove Datepicker if typeDate is 2
                            }
                        }
                        this.app.callEvent('casinoReport:filter', [filterdata]); // Trigger filter event
                    },
                },
            ],
        };

        return {
            // Return the complete form configuration
            view: 'form',
            rows: [upper_section, buttons],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The grid component.
     */
    init(grid) {
        webix.ready(function () {
            // Wait for webix to be ready
            if (profile.typeDate !== 2) {
                $$('Date').hide(); // Hide Date if typeDate is not 2
                $$('Datepicker').show(); // Show Datepicker
            } else {
                if (true) {
                    $$('Date').show(); // Show Date if typeDate is 2
                    $$('Datepicker').hide(); // Hide Datepicker
                }
            }
        });

        const lang = this.app.getService('locale').getLang(); // Get current language
        $$('Datepicker').attachEvent('onAfterRender', function () {
            devConfig.setDateModal(lang); // Set date modal configuration based on language
        });
    }
}

// FILE DOCUMENTED
